<template>
  <a-timeline-item v-bind="attrs" :class="bem.b()">
    <template
      v-for="item in Object.keys($slots).filter((slot) => slot !== 'dot')"
      #[item]="data"
    >
      <slot :name="item" v-bind="data || {}"></slot>
    </template>

    <template v-if="dotIcon || $slots.dot" #dot>
      <slot v-if="$slots.dot" name="dot"></slot>
      <ll-icon v-else :icon-name="dotIcon" color="inherit" />
    </template>
  </a-timeline-item>
</template>

<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import { useAttrs } from 'vue'
import { timelineItemProps } from './timeline'

defineOptions({ name: 'LlTimelineItem' })

const attrs = useAttrs()
const bem = createNamespace('timeline-item')

defineProps(timelineItemProps)
</script>
